module.exports = __webpack_public_path__ + "static/media/selfieErrorCameraImage.05e864b7.svg";